"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const d3_1 = require("d3");
const defaultChartTimeFormat_1 = __importDefault(require("../defaultChartTimeFormat"));
const AxisPosition_1 = require("../enums/AxisPosition");
class AxesManager {
    constructor(xAxisTickSize, yAxisTickSize, gridTickSize, chartTimeFormat) {
        this._xAxisTickSize = xAxisTickSize;
        this._yAxisTickSize = yAxisTickSize;
        this._gridTickSize = gridTickSize;
        this.serviceAxesHolder = [];
        this._chartTimeFormat = chartTimeFormat || defaultChartTimeFormat_1.default;
    }
    findServiceAxisByService(serviceId) {
        return this.serviceAxesHolder.find(x => x.serviceId == serviceId);
    }
    createAndScaleX(widthRange, domain) {
        this.x = (0, d3_1.scaleTime)().range(widthRange);
        this.xInitial = (0, d3_1.scaleTime)().range(widthRange);
        this.x.domain(domain).nice();
        this.xInitial.domain(this.x.domain()).nice();
    }
    createAndScaleY(serviceId, heightRange, domain, previewHeightRange = null) {
        const y = (0, d3_1.scaleLinear)().range(heightRange);
        const extendedDomain = [domain[0], domain[1]];
        y.domain(extendedDomain).nice();
        let yPreview = null;
        if (previewHeightRange != null) {
            yPreview = (0, d3_1.scaleLinear)().range(previewHeightRange);
            yPreview.domain(y.domain()).nice();
        }
        this.serviceAxesHolder.push({ serviceId: serviceId, y: y, yAxis: null, line: null, linePreview: null, yPreview: yPreview });
    }
    rescaleY(serviceId, heightRange, domain) {
        const y = (0, d3_1.scaleLinear)().range(heightRange);
        const extendedDomain = [domain[0], domain[1]];
        y.domain(extendedDomain).nice();
        this.serviceAxesHolder.find(service => {
            if (service.serviceId == serviceId) {
                service.y = y;
            }
        });
    }
    createXAxis() {
        const timeFormatter = this._chartTimeFormat;
        this.xAxis = (0, d3_1.axisBottom)(this.x)
            .ticks(this._xAxisTickSize).tickFormat(function (d) { return timeFormatter(d); });
        if (this.serviceAxesHolder.filter(x => x.yPreview != null).length > 0)
            this.xAxisPreview = (0, d3_1.axisBottom)(this.xInitial)
                .ticks(this._xAxisTickSize).tickFormat(function (d) { return timeFormatter(d); });
    }
    createYAxis(serviceId, axisPosition) {
        const serviceAxis = this.serviceAxesHolder.find(x => x.serviceId == serviceId);
        if (axisPosition == AxisPosition_1.AxisPosition.RIGHT_INSIDE || axisPosition == AxisPosition_1.AxisPosition.LEFT_OUTSIDE)
            serviceAxis.yAxis = (0, d3_1.axisLeft)(serviceAxis.y).ticks(this._yAxisTickSize);
        else if (axisPosition == AxisPosition_1.AxisPosition.LEFT_INSIDE || axisPosition == AxisPosition_1.AxisPosition.RIGHT_OUTSIDE)
            serviceAxis.yAxis = (0, d3_1.axisRight)(serviceAxis.y).ticks(this._yAxisTickSize);
        return serviceAxis.yAxis;
    }
    createLineDrawerForService(serviceId) {
        const serviceAxis = this.serviceAxesHolder.find(x => x.serviceId == serviceId);
        if (serviceAxis.line != null)
            return serviceAxis;
        const ctx = this;
        serviceAxis.line = (0, d3_1.line)()
            .x(function (d) { return ctx.x(d.time); })
            .y(function (d) { return serviceAxis.y(d.value); })
            .defined(function (d) { return d.value !== null; })
            .curve(d3_1.curveMonotoneX);
        if (this.serviceAxesHolder.filter(x => x.yPreview != null).length > 0) {
            serviceAxis.linePreview = (0, d3_1.line)()
                .x(function (d) { return ctx.xInitial(d.time); })
                .y(function (d) { return serviceAxis.yPreview(d.value); })
                .defined(function (d) { return d.value !== null; })
                .curve(d3_1.curveMonotoneX);
        }
        return serviceAxis;
    }
    createRectDrawerForService(serviceId) {
        const serviceAxis = this.serviceAxesHolder.find(x => x.serviceId == serviceId);
        if (serviceAxis.line != null)
            return serviceAxis;
        const ctx = this;
        serviceAxis.line = (0, d3_1.line)()
            .x(function (d) { return ctx.x(d.time + d.value); });
        return serviceAxis;
    }
    make_x_gridlines() {
        return (0, d3_1.axisBottom)(this.x).ticks(this._gridTickSize);
    }
    make_y_gridlines(serviceId) {
        const serviceAxis = this.serviceAxesHolder.find(x => x.serviceId == serviceId);
        return (0, d3_1.axisLeft)(serviceAxis.y).ticks(this._gridTickSize);
    }
    getDomainX() {
        return this.x.domain();
    }
    static isAxisPulledRight(axisPosition) {
        if (axisPosition == AxisPosition_1.AxisPosition.RIGHT_INSIDE || axisPosition == AxisPosition_1.AxisPosition.RIGHT_OUTSIDE)
            return true;
        else
            return false;
    }
}
exports.default = AxesManager;
